import App from "./App.svelte";
import "carbon-components-svelte/css/g90.css";
const app = new App({
    target: document.body,
    props: {},
});
export default app;
